/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfielddoorpricehint4Inputs */

const en_ticketsfielddoorpricehint4 = /** @type {(inputs: Ticketsfielddoorpricehint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Guests get the ticket for free and pay this amount at the door.`)
};

const de_ticketsfielddoorpricehint4 = /** @type {(inputs: Ticketsfielddoorpricehint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Gäste holen das Ticket kostenlos und zahlen diesen Betrag am Einlass.`)
};

/**
* | output |
* | --- |
* | "Optional. Guests get the ticket for free and pay this amount at the door." |
*
* @param {Ticketsfielddoorpricehint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfielddoorpricehint4 = /** @type {((inputs?: Ticketsfielddoorpricehint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfielddoorpricehint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfielddoorpricehint4(inputs)
	return de_ticketsfielddoorpricehint4(inputs)
});
export { ticketsfielddoorpricehint4 as "ticketsFieldDoorPriceHint" }